import { render, staticRenderFns } from "./WordCreateModal.vue?vue&type=template&id=b0abeb84&"
import script from "./WordCreateModal.vue?vue&type=script&lang=js&"
export * from "./WordCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports